const DEFAULT_LINE_HEIGHT_PX = 16

// `deltaY` is only expressed in pixels when deltaMode is DOM_DELTA_PIXEL — Firefox reports lines, and some setups report pages
export const wheelDeltaInPixels = (e: WheelEvent, el: HTMLElement) => {
  if (e.deltaMode === WheelEvent.DOM_DELTA_LINE) {
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
    return e.deltaY * (Number.isNaN(lineHeight) ? DEFAULT_LINE_HEIGHT_PX : lineHeight)
  }
  if (e.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
    return e.deltaY * el.clientHeight
  }
  return e.deltaY
}
